<template>
  <div
    ref="wrap"
    class="product-image-zoom h-full w-full"
    :class="{
      'product-image-zoom--ready': enabled,
      'product-image-zoom--on': enabled && active,
    }"
    :style="{ '--zx': originX, '--zy': originY }"
    @pointermove="onMove"
    @pointerleave="onLeave"
    @click="onClick"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { prefersReducedMotion } from '~/utils/storefrontExperience'

const props = withDefaults(defineProps<{
  enabled?: boolean
}>(), {
  enabled: false,
})

const wrap = ref<HTMLElement | null>(null)
const active = ref(false)
const originX = ref('50%')
const originY = ref('50%')

function setOrigin(event: PointerEvent) {
  const el = wrap.value
  if (!el) return
  const rect = el.getBoundingClientRect()
  if (!rect.width || !rect.height) return
  const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100))
  const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100))
  originX.value = `${x}%`
  originY.value = `${y}%`
}

function onMove(event: PointerEvent) {
  if (!props.enabled || prefersReducedMotion()) return
  setOrigin(event)
  if (event.pointerType === 'mouse') active.value = true
}

function onLeave() {
  active.value = false
  originX.value = '50%'
  originY.value = '50%'
}

function onClick(event: MouseEvent) {
  if (!props.enabled || prefersReducedMotion()) return
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return
  event.preventDefault()
  active.value = !active.value
}
</script>
